import React from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";

export default function SectionCard({ title, action, children }) {
  return (
    <Card className="rounded-2xl shadow-sm">
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{title}</Typography>
            {action}
          </Stack>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}